exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container[data-container]{position:absolute;background-color:#000;height:100%;width:100%}.container[data-container].pointer-enabled{cursor:pointer}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./src/components/container/public/style.scss
 ** module id = 129
 ** module chunks = 0
 **/